import dateMask from './dateMask'

const dateTimeMask = `${dateMask} HH:mm`

export default dateTimeMask
